import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
export function SalesHero() {
  return <Section className="pt-24 pb-16 md:pt-32 md:pb-24 text-center" data-id="element-139">
      <FadeIn data-id="element-140">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6 text-text-primary" data-id="element-141">
          Cobrás… y seguís ahogado.
        </h1>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-142">
        <h2 className="text-xl md:text-2xl text-text-secondary font-serif italic mb-12" data-id="element-143">
          No sos un desastre: estás sin sistema.
        </h2>
      </FadeIn>

      <div className="space-y-6 text-lg md:text-xl text-left leading-relaxed text-text-secondary" data-id="element-144">
        <FadeIn delay={0.2} data-id="element-145">
          <p data-id="element-146">Hay un momento que se repite.</p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-147">
          <p data-id="element-148">Te entra plata. Mirás el saldo. Y no sentís nada.</p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-149">
          <p className="font-medium text-text-primary" data-id="element-150">
            Ni alivio. Ni control. Ni “ok, estoy bien”.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-151">
          <p data-id="element-152">
            Solo una lista invisible de cosas que ya te están esperando:
            alquiler, tarjeta, servicios, impuestos, comida… y el mes que te
            corre como si te estuviera apurando a propósito.
          </p>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-153">
          <p data-id="element-154">
            Si sos monotributista o laburás por tu cuenta, esto no se arregla
            con “un presupuesto”.
          </p>
        </FadeIn>

        <FadeIn delay={0.7} data-id="element-155">
          <p className="font-serif text-xl md:text-2xl text-accent-teal font-medium mt-8" data-id="element-156">
            Se arregla con un sistema que funcione cuando cobrás irregular y
            cuando estás cansado.
          </p>
        </FadeIn>
      </div>

      <FadeIn delay={0.8} data-id="element-157">
        <div className="mt-16 pt-8 border-t border-warm-border" data-id="element-158">
          <p className="text-sm uppercase tracking-widest text-text-secondary font-medium" data-id="element-159">
            Esto es Monotributista en Calma
          </p>
        </div>
      </FadeIn>
    </Section>;
}